import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router'
import { ShopifyService } from '../services'

@Injectable({
	providedIn: 'root',
})
export class TokenGuard implements CanActivate {
	constructor(private shopifyService: ShopifyService) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		const params = route.queryParams
		if (params.vendor === 'shopify') {
			try {
				this.shopifyService.storeUrl = params.shop
				window['Intercom']('update', { user_id: params.shop })
				return true
			} catch (err) {
				return false
			}
		}
		return true
	}
}
